import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="develop"
        slug="utilities/type-style/develop/"
      />
      <Layout
        updated={changelog[data.title].lastUpdated}
        title={data.title}
        category={data.category}
        description={data.description}
        state="develop"
        site={data.site}
        changelog={changelog[data.title].changelog}
        slug="utilities/type-style/develop/"
      >
        <SectionTitle>Style Options</SectionTitle>
        <Showcase
          site={data.site}
          title="Type Alignment"
          code={code.alignment}
          variants={['u-type--left', 'u-type--center', 'u-type--right']}
        >
          <div class="full-width u-color--black">
            <p class="c-text-content u-type--left">
              The quick brown fox jumps over the lazy dog.
            </p>
            <p class="c-text-content u-type--center">
              The quick brown fox jumps over the lazy dog.
            </p>
            <p class="c-text-content u-type--right">
              The quick brown fox jumps over the lazy dog.
            </p>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Type Scale"
          code={code.scale}
          variants={[
            'u-type--xxsmall - 10px',
            'u-type--xsmall - 12px',
            'u-type--small - 14px',
            'u-type--medium - 16px',
            'u-type--large - 18px',
            'u-type--xlarge - 24px',
            'u-type--xxlarge - 32px',
            'u-type--xxxlarge - 44px',
          ]}
        >
          <div class="full-width u-color--black">
            <p class="c-text-content u-type--xxsmall">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--xsmall">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--small">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--medium">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--large">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--xlarge">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--xxlarge">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--xxxlarge">
              The five boxing wizards jump quickly.
            </p>
          </div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Type Decoration"
          code={code.style}
          variants={[
            'u-type--light',
            'u-type--normal',
            'u-type--bold',
            'u-type--italic',
            'u-type--underline',
          ]}
        >
          <div class="full-width u-color--black">
            <p class="c-text-content u-type--light">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--normal">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--bold">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--italic">
              The five boxing wizards jump quickly.
            </p>
            <p class="c-text-content u-type--underline">
              The five boxing wizards jump quickly.
            </p>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  style: `<p class="u-type--light">Text</p>
<p class="u-type--normal">Text</p>
<p class="u-type--bold">Text</p>
<p class="u-type--italic">Text</p>
<p class="u-type--underline">Text</p>
`,
  scale: `<p class="u-type--xxsmall">Text</p>
<p class="u-type--xsmall">Text</p>
<p class="u-type--small">Text</p>
<p class="u-type--medium">Text</p>
<p class="u-type--large">Text</p>
<p class="u-type--xlarge">Text</p>
<p class="u-type--xxlarge">Text</p>
<p class="u-type--xxxlarge">Text</p>
`,
  color: `<p class="u-type--primary">Text</p>
`,
  alignment: `<p class="u-type--left">Text</p>
<p class="u-type--center">Text</p>
<p class="u-type--right">Text</p>
`,
}
